import * as React from 'react';
import { SupplyDemand } from '../../components/SupplyDemand';
import { useSelector } from 'react-redux';
import { EChartTypes, ValuationChartsWidget } from '@cian/valuation-web-charts-widget';
import { useApplicationContext } from '../../utils/applicationContext';
import { today } from '../../utils/getTodayDate';
import { sub } from 'date-fns';
import { useGetSupplyDemandDiff } from './utils/useGetSupplyDemandDiff';
import { SupplyDemandFooter } from '../../components/SupplyDemand/components/SupplyDemandFooter';
import { useIsDesktop } from '@cian/valuation-utils-component';
import {
  trackOnSupplyDemandChartHover,
  trackPriceDemandExist,
  trackSupplyDemandTooltip,
  trackWhatIsMeanBtnClick,
} from './tracking';
import { SupplyDemandWrapper } from './components/SupplyDemandWrapper';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { trackSupplyDemandView } from '../../utils/teaser';
import { VIEWED_TIMEOUT } from '../../constants/viewedBlock';
import { ChartInfo } from '../../components/ChartInfo';
import { selectIsSupplyDemandLoading, selectSupplyDemandData } from '../../selectors/marketTrend';

export function SupplyDemandContainer() {
  const { logger } = useApplicationContext();
  const isDesktop = useIsDesktop();

  const wrapperRef = React.useRef(null);
  const [isInfoOpen, setInfoState] = React.useState(false);

  const {
    supplyTrand: supplyTrend,
    demandTrand: demandTrend,
    demandDiffTrand,
    supplyDiff,
    demandDiff,
    supplyDiffTrand,
    marketType,
    marketTypeDescription,
  } = useSelector(selectSupplyDemandData);
  const isLoading = useSelector(selectIsSupplyDemandLoading);

  React.useEffect(() => {
    trackPriceDemandExist();
  }, []);

  const handleOpenInfo = React.useCallback(() => {
    setInfoState(true);
    trackWhatIsMeanBtnClick();
  }, []);

  const handleOpenTooltip = React.useCallback(() => {
    trackSupplyDemandTooltip();
  }, []);

  const { supplyDiffData, demandDiffData } = useGetSupplyDemandDiff({
    demandDiffTrand,
    demandDiff,
    supplyDiffTrand,
    supplyDiff,
  });

  const chartInfoText = {
    magentaText: demandTrend.length ? 'Спрос' : null,
    blueText: supplyTrend.length ? 'Предложение' : null,
  };

  return (
    <ActionAfterViewObserver callback={trackSupplyDemandView} callbackDelay={VIEWED_TIMEOUT} wrapper={false}>
      <SupplyDemandWrapper ref={wrapperRef} isLoading={isLoading}>
        <SupplyDemand
          handleOpenTooltip={handleOpenTooltip}
          marketType={marketType}
          supplyDiffData={supplyDiffData}
          demandDiffData={demandDiffData}
          isInfoOpen={isInfoOpen}
          handleOpenInfo={handleOpenInfo}
          marketTypeDescription={marketTypeDescription}
          isDesktop={isDesktop}
        />
        <ChartInfo {...chartInfoText} />
        <ValuationChartsWidget
          key={supplyDiff}
          data={{
            dateMin: +sub(today(), { years: 1 }),
            dateMax: today(),
            supplyTrend,
            demandTrend,
            xScale: 'month',
          }}
          logger={logger}
          type={EChartTypes.SupplyDemand}
          onHover={trackOnSupplyDemandChartHover}
        />
        <SupplyDemandFooter />
      </SupplyDemandWrapper>
    </ActionAfterViewObserver>
  );
}
